"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Logs all actions and states after they are dispatched.
 */
var logger = function logger(store) {
    return function (next) {
        return function (action) {
            console.group(action.type);
            console.info("dispatching", action);
            var result = next(action);

            console.groupEnd(action.type);
            return result;
        };
    };
};

exports.default = logger;